<template>
  <div class="pt-3">
    <v-container v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                 v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
                 fluid>
      <v-row>
        <v-col cols="12" sm="7">
          <fin-lexicon-text :text="strategy.ruleDescription"
                            auto-solve
                            class="rules-desc mb-8"/>

          <v-row
            v-for="(rule, i) in strategy.rules"
            :key="i"
          >
            <v-col align="right" cols="3" sm="2">
              <v-avatar :color="strategyColor">
                <span class="rule-nr">{{ ++i }}</span>
              </v-avatar>
            </v-col>
            <v-col align-self="center" cols="9" sm="10">
              <fin-lexicon-text :text="rule"
                                auto-solve/>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import FinLexiconText from "@/components/common/lexicon/LexiconText/index"

export default {
  name: "finStrategyDetailsRulesTab",
  components: {FinLexiconText},
  props: {
    strategy: null,
    strategyColor: {
      type: String,
      default: 'transparent'
    }
  },
}
</script>

<style lang="scss" scoped>
.rules-desc {
  font-family: $body-font-family;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
  /* additional */
  white-space: pre-line;
}

.rule-nr {
  font-family: $heading-font-family;
  font-size: 25px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.32;
  letter-spacing: normal;
  text-align: center;
  color: $fin-color-primary-light;
}
</style>
